import { Injectable } from '@angular/core';
import { HubConnectionBuilder, HubConnection, LogLevel, HubConnectionState } from '@microsoft/signalr';
import { environment } from '../../../environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { BehaviorSubject } from 'rxjs';
import { MicroserviceResource, ConsoleLogMessage } from '../resources/microservice-resources';
@Injectable({
  providedIn: 'root'
})
export class SignalrService {

  public servicesReceived = new BehaviorSubject<MicroserviceResource[]>([]);
  public messagesReceived = new BehaviorSubject<ConsoleLogMessage[]>([]);
  public connectionStatusChanged = new BehaviorSubject<HubConnectionState>(HubConnectionState.Disconnected);
  private hubConnection: HubConnection | undefined;
  private isConnected: boolean;

  constructor(public readonly auth: OAuthService) {
    this._initHub();
  }

  public connect() {

    if(this.hubConnection.state === HubConnectionState.Connected)
      return;

    this._initHub();
  }

  public disconnect() {
    this.hubConnection.stop().then(() => {
      this.connectionStatusChanged.next(HubConnectionState.Disconnected);
    }).catch(err => console.error(err.toString()));

    // this.hubResourceService.destroy();
  }

  private _initHub() {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${environment.endpoints.api}/hubs/services`, {
        accessTokenFactory: () => this.auth.getAccessToken(),
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    this.hubConnection.onclose((error) => {
      // alert(`Realtime connection closed due to a server error. Please refresh this page to restart the connection.`);
      // console.log('Hub Connection Closed');
      this.connectionStatusChanged.next(this.hubConnection.state);
    });

    Object.defineProperty(WebSocket, 'OPEN', { value: 1 });

    this.hubConnection.start().then((value) => {
      // console.log('Connected to the hub!');
      this.connectionStatusChanged.next(HubConnectionState.Connected);
    }).catch((err) => console.error(err.toString()));

    this.hubConnection.on('Error', (err: string) => {
      console.log('hub error', err);
    });

    this.hubConnection.on('ReceiveMessages', (messages: ConsoleLogMessage[]) => {
      // console.log('messages received', messages);
      this.messagesReceived.next(messages);
    });

    this.hubConnection.on('ReceiveServiceList', (services: MicroserviceResource[]) => {
      // console.log('services received', services);
      this.servicesReceived.next(services);
    });
  }

  public listServices() {
    if(this.hubConnection.state != HubConnectionState.Connected)
      return;

    this.hubConnection.send('ListServices');
  }

  public joinChannel(name: string) {
    if(this.hubConnection.state != HubConnectionState.Connected)
      return;
    this.hubConnection.send('JoinServiceChannel', name, 50);
  }

  public leaveChannel(name: string): void {
    if(this.hubConnection.state != HubConnectionState.Connected)
      return;
    this.hubConnection.send('LeaveServiceChannel', name);
  }
}
